<template>
  <div :style="v2SideBarStyles">
    <div v-show="!loaderIsActive">
      <Overlay />
      <EditAppointmentModalV2 />
      <EmailTemplateBuilderModal />
      <CountdownTimerModal v-if="currentLocationId" />
      <UxToaster ref="UxToast" />
      <router-view v-if="!isUserSwitching" :class="classes" />
      <ImagePreviewModal />
      <UxMessageModal ref="UxMessageModal" />
      <!-- <ManualCallStatusModal /> -->
      <CommonConditionalComponents />
      <ContentAIModals v-if="currentLocationId" />
      <BrandBoardGlobalSettings v-if="currentLocationId" />
      <CopilotDrawer />
      <CopilotModal />
      <!-- why do we need  NewMessageModalV2 here, its giving this error:
<NewMessageModalV2> at src/pmd/pages/conversations/NewMessageModalV2.vue
       <PMDApp> at src/pmd/PMDApp.vue
         <Root>
-->
      <component v-if="showUpgradeModal" :is="upgradeModal" :source="upgradeModalSource" />
      <TrialEndPopup v-if="showTrialEndPopup" />
      <MediaFiles v-if="currentLocationId || isMediaFilesEnabled" />
      <AppReleaseCard v-if="this.user" :user="this.user" />
    </div>
    <AppLoader v-show="loaderIsActive" :user="this.user" />

    <!-- <PerformanceDebugger v-if="showPerformanceDebugger" /> -->
  </div>
</template>

<script lang="ts">
import { defineComponent, defineAsyncComponent, nextTick } from 'vue'

/* tslint:disable */
import $ from 'jquery'
import 'bootstrap'
import 'bootstrap-select'
import 'popper.js'
import 'vue-select/dist/vue-select.css'
import EditAppointmentModalV2 from '@/pmd/components/EditAppointmentModalV2.vue'
import GMBConnectionWarning from '@/pmd/components/GMBConnectionWarning.vue'
import GMBMessagingWarning from '@/pmd/components/GMBMessagingWarning.vue'
import Overlay from '@/pmd/components/sidebar/Overlay.vue'
import EmailTemplateBuilderModal from '@/pmd/pages/emailBuilder/EmailTemplateBuilderModal'
import CountdownTimerModal from '@/pmd/pages/countdown_timer/CountdownTimerModal.vue'
import { OauthService } from '@/services'
import * as Ux from '@/util/ux_message'
import handlebars from 'handlebars'
import moment from 'moment-timezone'
import postscribe from 'postscribe'
import { mapState } from 'vuex'
import { Company, User } from '../models'
import { USER_TYPE as userType } from '../models/user'
import { CompanyState, IframeState, UserState } from '../store/state_models'
import ImagePreviewModal from './components/ImagePreviewModal.vue'
import ManualCallStatusModal from './components/ManualCallStatusModal.vue'
import UxMessageModal from './components/util/UxMessageModal.vue'
import UxToaster from './components/util/UxToaster.vue'
import { CustomStorageCleanUp, CustomStorageManager, RouteHelper, Utilities } from './utils/CustomScriptHelper.ts'
import config from '@/config'
import { AgencyproPlusAddonPlan } from '@/models/company'
import { useEmitter } from '@/pmd/composition/useEmitter'
import * as Sentry from '@sentry/vue'
import firebase from 'firebase/compat/app'
import get from 'lodash-es/get'
import { Languages, localizationKey } from '../localization'
import { setSentryMeta } from '../plugins/sentry'
import { setRequestMetricsMeta } from '../plugins/requestMetrics'
import { customLogger } from '../plugins/sentry/customLogger'
import { IntegrationService } from '../services'
import { handleJobberLeadSourceCookie } from '../util/helper'
import { loadFreshChatWidgetScript, loadFreshWorksWidgets } from '../util/freshchat'
import AppReleaseCard from './components/app_release/appReleaseCard.vue'
import AppLoader from './loader/AppLoader.vue'
import { handlePushNotificationClickFromDesktop } from '../util/notification_helper'
import { EventBus } from '@/models/event-bus'
import { createStoreEventManager } from './utils/storeEvents.ts'
import BrandBoardGlobalSettings from './pages/brand_boards/GlobalSettings.vue'

declare const Canny: any

let timeout: NodeJS.Timer

const userData = {} as any
let companyData = {} as any

loadFreshChatWidgetScript()

const devEnv =
  ['development', 'staging', 'interop'].includes(process.env.NODE_ENV || '') &&
  process.env.VUE_APP_DISABLE_PERFORMANCE_DEBUGGER !== 'true'

export default defineComponent({
  name: 'PMDApp',
  metaInfo() {
    return {
      title: this.company?.name,
    }
  },
  components: {
    ImagePreviewModal,
    UxMessageModal,
    UxToaster,
    ManualCallStatusModal,
    GMBMessagingWarning,
    GMBConnectionWarning,
    Overlay,
    EditAppointmentModalV2,
    EmailTemplateBuilderModal,
    ContentAIModals: defineAsyncComponent(() => import('@/pmd/pages/content_ai/ContentAIModals.vue')),
    CopilotDrawer: defineAsyncComponent(() => import('@/pmd/pages/copilot/CopilotDrawer.vue')),
    CopilotModal: defineAsyncComponent(() => import('@/pmd/pages/copilot/CopilotModal.vue')),
    CommonConditionalComponents: defineAsyncComponent(() => import('@/pmd/components/CommonConditionalComponents.vue')),
    CountdownTimerModal,
    AppLoader,
    MediaFiles: defineAsyncComponent(() => import('@/pmd/pages/medias/MediaFilesModal.vue')),
    AppReleaseCard,
    TrialEndPopup: defineAsyncComponent(() => import('@/pmd/components/agency/billing/TrialEndPopup.vue')),
    // PerformanceDebugger: devEnv
    //   ? defineAsyncComponent(() => import('@/components/performance-debugger-ui/PerformanceDebugger.vue'))
    //   : undefined,
    BrandBoardGlobalSettings,
  },
  data() {
    return {
      authUser: {} as any,
      currentLocationId: '',
      collapseSideBarValue: false,
      customScripts: {
        style: undefined as string | undefined,
        js: undefined as any,
      },
      emitter: useEmitter(),
      showUpgradeModal: false,
      upgradeModalSource: '',
      upgradeModal: null,
      showTrialEndPopup: false,
      isDev: devEnv,
      showPerformanceDebugger: false,
    }
  },
  async created() {
    this.$store.dispatch('init')
    this.authUser = await this.$store.dispatch('auth/get')
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    if (window.isElectron) {
      window.addEventListener('message', this.handleMessage)
    }
  },
  computed: {
    loaderIsActive() {
      return this.$store.state.locationLoaderActive || this.$store.state.agencyLoaderActive
    },
    isUserSwitching() {
      return this.$store.getters['auth/isUserSwitching']
    },
    ...mapState('company', {
      company: (s: CompanyState) => {
        return s.company ? new Company(s.company) : undefined
      },
    }),
    ...mapState('user', {
      user: (s: UserState) => {
        return s.user ? new User(JSON.parse(JSON.stringify(s.user))) : undefined
      },
    }),
    ...mapState('locations', ['locations']),
    collapseSideBar() {
      return this.$store.getters.getManualCollapseSidebar
    },
    ...mapState('iframe', {
      iframe: (s: IframeState) => {
        return s.handshake || undefined
      },
    }),
    isV2SideBarEnabled() {
      return this.$store.getters['sidebarv2/getVersion'] == 'v2'
    },
    classes() {
      let classes = ''
      classes +=
        this.collapseSideBar && !!this.$route.params.location_id
          ? `pmd-app ${this.$route.params.location_id}`
          : !!this.$route.params.location_id
          ? `${this.$route.params.location_id}`
          : ''
      classes += this.isV2SideBarEnabled ? ' flex' : ''
      classes += this.collapseSideBar ? ' v2-collapse' : ' v2-open'
      classes += ` ${this.v2Id}`
      return classes
    },
    v2Id() {
      if (!this.$route.params.location_id) {
        if (this.$route.name === 'account_team_management') {
          return this.isV2SideBarEnabled ? 'sidebar-v2-agency sidebar-v2-agency-padding' : ''
        }
        return this.isV2SideBarEnabled ? 'sidebar-v2-agency' : ''
      } else {
        return this.isV2SideBarEnabled && this.isV2SideBarRoute && !this.isOnbording ? 'sidebar-v2-location' : ''
      }
    },
    isV2SideBarRoute() {
      return this.$route.path.includes('/v2/location')
    },
    isElectronApp() {
      return window.isElectron || false
    },
    v2SideBarStyles() {
      if (!this.$route.params.location_id) {
        return this.isV2SideBarEnabled
          ? 'padding-top: 0px !important; overflow: hidden; height: 100vh; width: 100%;'
          : undefined
      } else {
        return this.isV2SideBarEnabled && this.isV2SideBarRoute
          ? 'padding-top: 0px !important; overflow: hidden; height: 100vh;'
          : undefined
      }
    },
    isOnbording() {
      return (
        this.$router.currentRoute.value.query?.onboarding && this.$router.currentRoute.value.query?.onboarding == 'true'
      )
    },
    isInternalUser() {
      return this.$store.state.user.internalUser
    },
    userAndCompany() {
      return !!this.user && !!this.company
    },
    showTermsOfService() {
      return (
        this.company &&
        this.user &&
        !this.isInternalUser &&
        this.company.termsOfServiceVersion &&
        this.company.termsOfServiceVersion !== config.tosVersion
      )
    },
    isMediaFilesEnabled() {
      return (
        this.$route.name === 'template_library_admin' ||
        this.$route.name === 'default-emails' ||
        this.$route.name === 'saas-builder-labs'
      )
    },
  },
  provide: function () {
    return {
      uxmessage: this.uxmessage,
    }
  },
  watch: {
    '$route.params.location_id': function (id) {
      const metadata = {
        userId: get(this.user, 'id'),
        companyId: get(this.user, 'companyId'),
        locationId: id,
        email: get(this.user, '_data.email'),
        locale: localStorage.getItem(localizationKey) || Languages.English_US,
      }
      setSentryMeta(metadata)
      setRequestMetricsMeta(metadata)
      if (this.$route.params.location_id) {
        this.currentLocationId = id
      }

      this.updateStyles() // Due to vue2 app mount behavior
    },
    user: function (newUser, oldUser) {
      if (!oldUser && newUser) {
        if (newUser.type === 'agency') {
          this.identifyCanny()
        }
        const metadata = {
          userId: get(this.user, 'id'),
          companyId: get(this.user, 'companyId'),
          locationId: get(this.$route, 'params.location_id'),
          email: get(this.user, '_data.email'),
          locale: localStorage.getItem(localizationKey) || Languages.English_US,
        }
        setSentryMeta(metadata)
        setRequestMetricsMeta(metadata)
      }
      if (!newUser && oldUser) {
        Sentry.setUser(null)
      }
    },
    company: async function (newCompany, oldCompany) {
      this.identifyCanny()

      handleJobberLeadSourceCookie(newCompany, oldCompany)

      const isCompanyChanged = oldCompany && newCompany && oldCompany._id != newCompany._id
      if ((!oldCompany && newCompany) || isCompanyChanged) {
        if (newCompany.logoURL) {
          $('link[rel="icon"]').attr('href', newCompany.logoURL)
        }
        if (newCompany.name) {
          $('head').append(`<title>${newCompany.name}</title>`)
        }
        await this.getCustomScripts(newCompany?._id)
        if (!(window as any).exposeSessionDetails) {
          ;(window as any).exposeSessionDetails = this.exposeSessionDetails
        }
        if (!(window as any).AppUtils) {
          this.getAppUtils()
        }
        let jsParams = {}
        if (this.user) {
          jsParams = { user: this.user, userId: this.user.id }
        } else if (!this.user) {
          const user = await this.$store.dispatch('user/get')
          if (user) {
            jsParams = { user, userId: user?.id || null }
          } else {
            // fallback if user is not available
            jsParams = { user: null, userId: null }
          }
        }
        if (isCompanyChanged) {
          const customJs = document.querySelector('#customJS')
          if (customJs) {
            customJs.innerHTML = ''
          }
          const customCSS = document.querySelector('#customCss')
          if (customCSS) {
            customCSS.innerHTML = ''
          }
          const customJsContainer = document.querySelector('#custom-js-integrations')
          if (customJsContainer) {
            customJsContainer.innerHTML = ''
          }
          const customCssContainer = document.querySelector('#custom-style-marketplace-integrations')
          if (customCssContainer) {
            customCssContainer.innerHTML = ''
          }
        }

        const isCustomJsDisabled = this.$store.getters['supportPreferences/isCustomJsDisabled']
        const isCustomCssDisabled = this.$store.getters['supportPreferences/isCustomCssDisabled']

        if (!isCustomJsDisabled && newCompany && newCompany.customJavascript) {
          const customJsContainer = document.querySelector('#customJS')
          if (customJsContainer) {
            customJsContainer.innerHTML = ''
          }
          try {
            postscribe(
              '#customJS',
              handlebars.compile(newCompany.customJavascript)(jsParams, {
                allowProtoPropertiesByDefault: true,
              }),
              {
                done: function () {
                  const customJavascript = newCompany.customJavascript
                  if (customJavascript.includes('birdseed') || customJavascript.includes('helpwise')) {
                    const evt = document.createEvent('Event')
                    evt.initEvent('load', false, false)
                    window.dispatchEvent(evt)
                  }
                },
              }
            )
          } catch (err) {
            console.log('Error in custom JS processing', err)
          }
          // } else {
          //   if (
          //     ['app.gohighlevel.com', 'localhost:8080'].indexOf(location.host) !==
          //     -1
          //   ) {
          //     /*<![CDATA[*/
          //     window.groove = window.groove || {}
          //     groove.widget = function() {
          //       groove._widgetQueue.push(Array.prototype.slice.call(arguments))
          //     }
          //     groove._widgetQueue = []
          //     groove.widget('setWidgetId', '44231df8-7404-ffad-6a81-3f534fd3b329')
          //     !(function(g, r, v) {
          //       var a,
          //         n,
          //         c = r.createElement('iframe')
          //       ;((c.frameElement || c).style.cssText =
          //         'width: 0; height: 0; border: 0'),
          //         (c.title = ''),
          //         (c.role = 'presentation'),
          //         (c.src = 'javascript:false'),
          //         r.body.appendChild(c)
          //       try {
          //         a = c.contentWindow.document
          //       } catch (i) {
          //         n = r.domain
          //         var b = [
          //           "javascript:document.write('<he",
          //           'ad><scri',
          //           'pt>document.domain=',
          //           '"',
          //           n,
          //           '";</scri',
          //           'pt></he',
          //           'ad><bo',
          //           'dy></bo',
          //           "dy>')"
          //         ]
          //         ;(c.src = b.join('')), (a = c.contentWindow.document)
          //       }
          //       var d = 'https:' == r.location.protocol ? 'https://' : 'http://',
          //         s = 'http://groove-widget-production.s3.amazonaws.com'.replace(
          //           'http://',
          //           d
          //         )
          //       ;(c.className = 'grv-widget-tag'),
          //         (a.open()._l = function() {
          //           n && (this.domain = n)
          //           var t = this.createElement('script')
          //           ;(t.type = 'text/javascript'),
          //             (t.charset = 'utf-8'),
          //             (t.async = !0),
          //             (t.src = s + '/loader.js'),
          //             this.body.appendChild(t)
          //         })
          //       var p = ['<bo', 'dy onload="document._l();">']
          //       a.write(p.join('')), a.close()
          //     })(window, document)
          //     /*]]>*/
          //   }
        }

        if (!isCustomCssDisabled && newCompany && newCompany.customCSS) {
          let customCSS: any = document.querySelector('#customCss')
          if (customCSS) {
            customCSS.innerHTML = ''
          } else {
            customCSS = document.createElement('style')
            customCSS.id = 'customCss'
          }
          customCSS.type = 'text/css'
          customCSS.media = 'screen'
          customCSS.appendChild(document.createTextNode(newCompany.customCSS))
          document.head.appendChild(customCSS)
        }
        //Custom Scripts from Marketplace
        if (this.customScripts?.length) {
          const customJsContainer = document.querySelector('#custom-js-integrations')
          if (customJsContainer) {
            customJsContainer.innerHTML = ''
          }
          const customCssStyles = document.querySelectorAll('style[id^="custom-style-marketplace-integrations"]')
          if (customCssStyles?.length) {
            customCssStyles.forEach(style => style.remove())
          }
          Object.values(this.customScripts)?.forEach((script: any) => {
            if (!isCustomJsDisabled && script?.customJS?.length) {
              const newDiv = document.createElement('div')
              newDiv.id = script?.id
              const node = document.querySelector('#custom-js-integrations')?.appendChild(newDiv)
              if (node) {
                try {
                  postscribe(
                    `#${script?.id}`,
                    handlebars.compile(script?.customJS)(jsParams, {
                      allowProtoPropertiesByDefault: true,
                    }),
                    {
                      afterAsync: function () {
                        const customJavascript = script?.customJS
                        if (customJavascript.includes('birdseed') || customJavascript.includes('helpwise')) {
                          const evt = document.createEvent('Event')
                          evt.initEvent('load', false, false)
                          window.dispatchEvent(evt)
                        }
                      },
                    }
                  )
                } catch (err) {
                  console.log(`Custom JavaScript Failed for id: ${script?.id}`, err?.message, err)
                }
              }
            }
            if (!isCustomCssDisabled && script?.customCSS?.length) {
              const customCSS = document.createElement('style')
              customCSS.type = 'text/css'
              customCSS.media = 'screen'
              customCSS.id = `custom-style-marketplace-integrations-${script?.id}`
              customCSS.appendChild(document.createTextNode(script.customCSS))
              document.head.appendChild(customCSS)
            }
          })
        }

        if (newCompany && newCompany.theme) {
          document.body.dataset.theme = newCompany.theme
        } else if (this.isV2SideBarEnabled && !newCompany.theme) {
          document.body.dataset.theme = 'default-dark-v1'
        }
      }
    },
    userAndCompany: function (newValue) {
      if (newValue && this.user.type === 'agency') {
        const datePurchase = this.company.billingInfo?.first_payment_date
          ? moment(this.company.billingInfo?.first_payment_date?.seconds * 1000).format('MMM DD, YYYY HH:mm')
          : ''
        const daySincePurchase = this.company.billingInfo?.first_payment_date
          ? moment().diff(this.company.billingInfo?.first_payment_date?.seconds * 1000, 'days')
          : ''
        const firstImplementationCallDate = this.company.onboardingInfo.meta_data?.first_implementation_call_date
          ? moment(this.company.onboardingInfo.meta_data?.first_implementation_call_date?.seconds * 1000).format(
              'MMM DD,YYYY'
            )
          : '' || ''
        const implementationCSR1 = this.company.onboardingInfo.meta_data?.implementation_csr_1 || ''
        const firstCaptureCallDate = this.company.onboardingInfo.meta_data?.first_capture_call_date
          ? moment(this.company.onboardingInfo.meta_data?.first_capture_call_date?.seconds * 1000).format('MMM DD,YYYY')
          : '' || ''
        companyData = {
          id: this.company.id,
          name: this.company.name || '',
          email: this.company.email || '',
          status: this.company.status || '',
          activePlan: this.company.stripeActivePlan || '',
          created: moment(this.company.dateAdded).format('MMM DD, YYYY'),
          relationshipNumber: this.company.relationshipNumber,
          prioritySupport:
            this.company.premiumUpgraded ||
            (this.company.jumpstartSupported && this.company.jumpstartSupported.seconds * 1000 >= +new Date()) ||
            false,
          datePurchase: datePurchase,
          daySincePurchase: daySincePurchase,
          firstImplementationCallDate: firstImplementationCallDate,
          implementationCSR1: implementationCSR1,
          firstCaptureCallDate,
          stripeId: this.company.stripeId,
          locationCount: this.company.locationCount || 0,
        }
        userData.id = this.user.id
        userData.name = this.user.name
        userData.email = this.user.email
        userData.phone = this.user.phone
        this.$store.dispatch('freshchat/syncUserData', userData)
        this.$store.dispatch('freshchat/syncCompanyData', companyData)
        if (localStorage.getItem('proxyLoadSupport')) {
          loadFreshChatWidgetScript().then(() => {
            loadFreshWorksWidgets()
          })
        }
      }
      if (newValue) {
        if (this.company?.billingInfo?.trial_end_date && this.user.type === 'agency' && this.user.role === 'admin') {
          const isAgencyInTrial =
            this.company.status === 'active_trial' || this.company.status === 'active_trial-extension'
          const trialEndDate = moment.unix(this.company.billingInfo.trial_end_date.seconds)
          const hasJoinedKickoffCall = this.company?.onboardingInfo?.hasJoinedKickoffCall
          const daysLeft = trialEndDate.diff(moment(), 'days')
          const isTrialEndPopupClosed = localStorage.getItem(`trial-end-popup-closed-${this.company?.id}`) === 'true'
          const isOnboardingPending = this.company.onboardingInfo.pending

          if (
            daysLeft <= 4 &&
            !hasJoinedKickoffCall &&
            !isTrialEndPopupClosed &&
            isAgencyInTrial &&
            isOnboardingPending === false
          ) {
            this.loadTrialEndPopup()
          }
        }
        
      }
    },
  },
  methods: {
    uxmessage(item: Ux.UxMessage, toastIt: boolean = false) {
      if (toastIt) this.$refs['UxToast'].show(item)
      else this.$refs['UxMessageModal'].show(item)
    },
    handleMessage(e: MessageEvent) {
      // Handle desktop app messages
      if (window.isElectron) {
        if (e.data.messageType === 'ELECTRON_NOTIFICATION_CLICKED') {
          handlePushNotificationClickFromDesktop(e.data.notificationData)
        }
      }
    },
    refreshTimer() {
      const _self = this
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        _self.signout()
      }, 30 * 60 * 1000)
    },
    async signout() {
      await this.$store.dispatch('logout')
      await this.$router.push({ name: 'login', query: { logout: 'true' } })
    },
    isAgencyOwner() {
      return (
        this.user?.type === userType.AGENCY && (this.user?._data?.is_agency_owner || this.user?._data?.isAgencyOwner)
      )
    },
    identifyCanny() {
      try {
        if (!this.user || !this.company || !window.Canny || (this.user && this.user.type == 'account')) {
          return
        }
        Canny('identify', {
          appID: '612f76b3a11bf815b4eb024b',
          user: {
            companies: [
              {
                created: moment(this.company.dateAdded).toISOString(),
                id: this.company.id, //agencyid required
                monthlySpend: this.company.stripeActivePlan ? parseInt(this.company.stripeActivePlan.split('_')[2]) : 0, // required 97/297/497
                name: this.company.name, // required agency name
                customFields: {
                  activePlan: this.company.stripeActivePlan || '',
                  status: this.company.status || '',
                  country: this.company.country || '',
                  relationship_number: this.company.relationshipNumber || '',
                  customer_success_rep: this.company.onboardingInfo.meta_data?.customer_success_rep || '',
                  // agency_type: 'b2b/ saas/ own customer', // bhaibab
                },
              },
            ],

            created: moment(this.user?._data?.date_added?.seconds * 1000).toISOString(),
            email: this.user?.email || '',
            id: this.user?.id || '',
            name: this.user?.fullName || '',
            customFields: {
              user_role: this.user?.role,
              user_type: this.user?.type,
            },
          },
        })
      } catch (err) {
        console.log('Canny Identify Failed !!', err)
      }
    },
    async getCustomScripts(companyId?: string) {
      try {
        if (this.user?.companyId ?? companyId) {
          const response = await IntegrationService.MarketplaceIntegrations.getCustomScripts(
            this.user?.companyId ?? companyId
          )
          if (response?.success) {
            this.customScripts = response?.scripts || []
          }
        }
      } catch (err) {
        console.error('Failed to fetch custom Scripts', err)
      }
    },
    async exposeSessionDetails(appId: number) {
      try {
        if (!appId) {
          console.error('AppId is required to expose session details')
          return
        }
        const res = await OauthService.getUserSessionJWT(appId, this.$router.currentRoute.value.params.location_id)
        return res.data
      } catch (error) {
        console.error('Failed to expose session details', error)
      }
    },
    async loadUpgradeModal(source: string) {
      this.showUpgradeModal = false
      this.upgradeModal = (await import('./components/agency/billing/UpgradeModalV3.vue')).default
      this.showUpgradeModal = true
      this.upgradeModalSource = source
    },
    async loadTrialEndPopup() {
      this.showTrialEndPopup = true
    },
    getAppUtils() {
      try {
        const storage = new CustomStorageManager()
        const storeEvents = createStoreEventManager()
        ;(window as any).AppUtils = {
          Storage: storage,
          Utilities,
          RouteHelper,
          StoreEvents: {
            register: storeEvents.register,
            unregister: storeEvents.unregister,
          },
        }
      } catch (err) {
        console.log(err)
      }
    },
    async cleanupCustomStorage() {
      try {
        const storage = new CustomStorageCleanUp()
        await storage.clear()
      } catch (err) {
        console.log('cleanupCustomStorage failed: ', err)
      }
    },
    handleBeforeUnload() {
      localStorage.setItem('lastRefresh', new Date().toISOString())
    },
    initCDNScript() {
      if (!document.getElementById('ad-publishing-testentry')) {
        const script = document.createElement('script')
        script.id = 'ad-publishing-testentry'
        script.src = 'https://appcdn.leadconnectorhq.com/automation-reporting/ad-publishing/testentry.js'
        script.async = true
        document.body.appendChild(script)
      }
    },
    updateStyles() {
      const appElement = document.getElementById('app')
      if (appElement && this.v2SideBarStyles) {
        appElement.style.cssText = this.v2SideBarStyles
      }
    },
  },
  async mounted() {
    if (!String.prototype.replaceAll) {
      window.String.prototype.replaceAll = (str, match, replacement) => {
        return str.replace(new RegExp(match.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), () => replacement)
      }
    }

    this.emitter.on('show-agency-plan-upgrade-modal', (data: { source: string }) => {
      this.loadUpgradeModal(data.source)
    })


    // if (devEnv) {
    //  EventBus.$on('toggle-performance-debugger', () => {
    //     this.showPerformanceDebugger = !this.showPerformanceDebugger
    //   })

    // const storedVisibility = localStorage.getItem('performance-debugger-visible');
    // if (storedVisibility !== null && storedVisibility === 'true') {
    //   this.showPerformanceDebugger = true
    // }

    nextTick(() => {
      this.initCDNScript()
      this.updateStyles()
    })
  },

  async beforeUnmount() {
    await this.cleanupCustomStorage()
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    if (window.isElectron) {
      window.removeEventListener('message', this.handleMessage)
    }
    EventBus.$off('toggle-performance-debugger')
  },
})
</script>

<style>
@import '../assets/pmd/css/styles.css';
@import '../assets/pmd/css/styles.patch.css';
@import '../assets/pmd/css/styles.patch.scss';

.pmd-app .hl_wrapper {
  padding-left: 70px;
}
</style>

<style lang="scss">
@use '@/assets/pmd/css/styles.sidebar.scss' as sidebar;
@use '@/assets/pmd/css/styles.sidebar.light.scss' as sidebar-light;
/*@import '@/assets/pmd/css/styles.sidebar.dark.scss';*/

:root {
  --sidebar-bg-color: #0c2d3f;
  --sidebar-parent-active-li-bg-color: rgba(24, 139, 246, 0.1);
  --sidebar-li-color: #ffffff;
  --sidebar-collapse-li-bg-color: #103855;
  --custom-link-color: #38a0db;
  --custom-primary: #178af6;
  --custom-primary-border-color: rgba(24, 139, 246, 0.1);
  --custom-yellow-color: #ff6600;
  --custom-yellow-active: #ff9900;
  --custom-yellow-border-color: #ff6600;
  --button-icon-color: #ffffff;
  --loader-color: #0c2d3f;
  --login--header-border-color: rgba(144, 164, 174, 0.2);
  --settings-tab-link-color: #607179;
}

body[data-theme='default-dark-v1'] {
  // @import url('https://fonts.googleapis.com/css2?family=Calibri');

  nav#navbar {
    background: var(--sidebar-bg-color);
  }

  .hl_navbar--links > li .nav-marketing-links ul li.active a,
  .hl_navbar--links > li .nav-dropdown-links ul li.active a {
    color: var(--custom-link-color);
  }

  .hl_navbar--links > li.active > a {
    color: var(--sidebar-li-color);
    font-weight: 500;
    background: var(--sidebar-parent-active-li-bg-color);
  }

  .hl_navbar--links > li a {
    display: block;
    padding: 15px 25px;
    color: var(--sidebar-li-color);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-transition: none;
    transition: none;
    font-weight: 500;
  }

  .btn.btn-primary {
    background-color: var(--custom-primary);
    border-color: var(--custom-border-color);
    color: var(--button-icon-color);
  }

  .btn.btn-yellow {
    background-color: var(--custom-yellow-color);
    border-color: var(--custom-yellow-border-color);
    color: var(--button-icon-color);
  }

  .btn.btn-yellow:active,
  .btn.btn-yellow:focus,
  .btn.btn-yellow:hover {
    color: var(--button-icon-color);
    background-color: var(--custom-yellow-active);
    border-color: var(--custom-yellow-active);
  }

  .hl_settings--nav li.active a,
  .hl_settings--nav li.hover a {
    color: var(--custom-link-color);
    font-weight: 500;
    border-color: var(--custom-link-color);
  }

  a:not(.btn) {
    color: var(--custom-link-color);
    text-decoration: none;
    // background-color: transparent;
    -webkit-text-decoration-skip: objects;
  }

  a:not(.btn):hover {
    color: var(--custom-link-color);
    text-decoration: none;
    // background-color: transparent;
    -webkit-text-decoration-skip: objects;
  }

  .hl_settings--nav a {
    color: var(--settings-tab-link-color);

    &:hover {
      color: var(--settings-tab-link-color);
    }
  }

  .hl_marketing--nav li.active a {
    color: var(--custom-link-color);
    font-weight: 500;
    border-color: var(--custom-link-color);
  }

  button.hl_navbar--button.btn.btn-success.btn-block {
    background: var(--custom-link-color);
  }

  .hl_navbar--links > li .nav-dropdown-links,
  .hl_navbar--links > li .nav-marketing-links {
    background-color: var(--sidebar-collapse-li-bg-color);
    border-top: 1px solid var(--sidebar-collapse-li-bg-color);
    border-bottom: 1px solid var(--sidebar-collapse-li-bg-color);
  }

  .hl_navbar--toggle {
    top: auto;
    bottom: 10px;
    right: 0;
  }

  .hl_navbar--toggle.collapse {
    position: absolute;
    left: 0;
    margin: auto;
  }

  .hl_controls .hl_controls--right .btn-sm .icon,
  .hl_controls .hl_controls--right .btn-group-sm > .btn .icon {
    color: var(---button-icon-color);
  }

  .lds-grid div {
    background: var(--loader-color);
  }

  .hl_conversations--message > .hl_conversations--message-body .messages-single a {
    color: var(---button-icon-color);
    text-decoration: underline;
  }

  .launchpad-progress-incomplete {
    background: #fff !important;
  }
}

/*Reusable classes START*/
.hl_calltoaction-btn {
  background: #27ae60;
  border-radius: 3px;
  padding: 7px 20px;
  border: unset;
  color: #fff;
}

.hl_center {
  height: 100%;
  display: grid;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.hl_compact_header {
  padding: 10px 15px;
}

.hl_text_center {
  text-align: center;
}

.hl_new_badge {
  display: block;
  padding: 0 4px;
  line-height: 15px;
  font-size: 0.8rem;
  margin: -16px 10px 0 5px;
  border: 1px solid #af8205;
  border-radius: 3px;
  background: #ffbc00;
  color: #0c2d3f;
}

/*Reusable classes FINISH*/

/* Chatbot widget style START */
#mobile-chat-container {
  /** TO HIDE the Freshbot Widget **/
  display: none !important;
}

// a tag color changed to white.
.chat-container .chat-history .other-message a {
  color: #fff !important;
}

.hl_force-block {
  display: block !important;
}

.hl-loader-container {
  background: #f0fdfe;
}

/* Chatbot widget style FINISH */
</style>
